'use client';

import {StepPayload} from '@blesk-frontend/api';
import {EllipsisVertical} from 'lucide-react';
import {ButtonSquare, Popper} from '../../components';
import {ImageEditorModal} from '../../image-editor';
import {useModal} from '../../providers/ModalProvider';
import {StepMenu} from './StepMenu';

interface StepToolbarRightProps {
  step: StepPayload;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onUpdate: (step: StepPayload) => void;
  onDuplicate: () => void;
  onDelete: () => void;
}

export const StepToolbarRight = ({
  step,
  onMoveUp,
  onMoveDown,
  onUpdate,
  onDuplicate,
  onDelete,
}: StepToolbarRightProps) => {
  const openEditModal = useModal(
    (props) => <ImageEditorModal step={step} onChange={onUpdate} {...props} />,
    {reduceMotion: true, removeBackground: true},
  );

  const onToggleHideStep = () => {
    onUpdate({...step, meta: {...step.meta, hidden: !step.meta.hidden}});
  };

  const onDuplicateStep = () => {
    onDuplicate();
  };

  const onEditScreenshot = () => {
    openEditModal();
  };

  const onUploadScreenshot = (src: string) => {
    onUpdate({
      ...step,
      src: {original: src, edited: src},
      element: {selector: null, text: step.element.text},
      editor: {crop: null, rects: []},
    });
  };

  const onDeleteScreenshot = () => {
    onUpdate({
      ...step,
      src: {original: '', edited: null, cropped: null},
      element: {selector: null, text: step.element.text},
      editor: {crop: null, rects: []},
    });
  };

  return (
    <div className="pointer-events-auto flex items-center gap-1">
      <Popper
        menu={
          <StepMenu
            step={step}
            onMoveUp={onMoveUp}
            onMoveDown={onMoveDown}
            onToggleHideStep={onToggleHideStep}
            onDuplicateStep={onDuplicateStep}
            onDeleteStep={onDelete}
            onEditScreenshot={onEditScreenshot}
            onUploadScreenshot={onUploadScreenshot}
            onDeleteScreenshot={onDeleteScreenshot}
          />
        }
        placement="bottom-start"
      >
        <ButtonSquare>
          <EllipsisVertical className="size-6" />
        </ButtonSquare>
      </Popper>
    </div>
  );
};
